export default {
    javascriptLibrary: []
}